import { render, staticRenderFns } from "./PasswordResetNewPasswordSection.vue?vue&type=template&id=82ed4d30&scoped=true"
import script from "./PasswordResetNewPasswordSection.vue?vue&type=script&lang=ts"
export * from "./PasswordResetNewPasswordSection.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetNewPasswordSection.vue?vue&type=style&index=0&id=82ed4d30&prod&lang=scss&scoped=true"
import style1 from "./PasswordResetNewPasswordSection.vue?vue&type=style&index=1&id=82ed4d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ed4d30",
  null
  
)

export default component.exports